import type { ReactNode } from 'react';
import { cn } from '@shared/utils';
import { Input } from '@shared/widgets';
import LoopIcon from '@assets/images/search_FILL0_wght400_GRAD0_opsz24.svg';

interface TableHeaderProps {
  className?: string;
  open: boolean;
  onToggle: React.ActionDispatch<[]>;
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
}

export const TableHeader = (props: TableHeaderProps) => {
  return (
    <div className={cn('flex w-full flex-col items-stretch px-1', props.className)}>
      <div className='flex items-center justify-center gap-2 uppercase'>
        {props.children}
        <LoopIcon className='inline-block cursor-pointer' onClick={props.onToggle} />
      </div>
      {props.open && (
        <div>
          <Input inputClassName='!h-[20px] bg-[#fff]' value={props.value} onChange={props.onChange} />
        </div>
      )}
    </div>
  );
};
